export const originalAccordion = () => {
  const triggers = document.querySelectorAll(
    '[data-target], [data-open-target], [data-close-target]',
  );

  triggers.forEach((trigger) => {
    const openSelector = trigger.getAttribute('data-open-target');
    const closeSelector = trigger.getAttribute('data-close-target');
    const toggleSelector = trigger.getAttribute('data-target');

    const targetSelector = openSelector || closeSelector || toggleSelector;
    const target = document.querySelector(targetSelector);
    if (!target) return;

    // ページロード時に初期状態をチェック
    const initializeAccordionState = () => {
      if (target.classList.contains('is-open-default')) {
        target.classList.add('is-open');
        trigger.classList.add('is-active');
        target.style.maxHeight = 'none';
        // is-open-defaultクラスは初期化後に削除
        target.classList.remove('is-open-default');
      }
    };

    // 初期化実行
    initializeAccordionState();

    trigger.addEventListener('click', (e) => {
      const isOpen = target.classList.contains('is-open');

      // 「開く」トリガー
      if (openSelector) {
        if (isOpen) return; // 既に開いていれば何もしない

        target.classList.add('is-open');
        trigger.classList.add('is-active');
        target.style.maxHeight = '0px';

        requestAnimationFrame(() => {
          target.style.maxHeight = target.scrollHeight + 'px';
        });
        return;
      }

      // 「閉じる」トリガー
      if (closeSelector) {
        if (!isOpen) return; // 閉じていれば何もしない

        target.style.maxHeight = target.scrollHeight + 'px';
        requestAnimationFrame(() => {
          target.style.maxHeight = '0px';
          target.classList.remove('is-open');
          trigger.classList.remove('is-active');
        });
        return;
      }

      // 「トグル」トリガー（デフォルト）
      if (toggleSelector) {
        if (isOpen) {
          target.style.maxHeight = target.scrollHeight + 'px';
          requestAnimationFrame(() => {
            target.style.maxHeight = '0px';
            target.classList.remove('is-open');
            trigger.classList.remove('is-active');
          });
        } else {
          target.classList.add('is-open');
          trigger.classList.add('is-active');
          target.style.maxHeight = '0px';

          requestAnimationFrame(() => {
            target.style.maxHeight = target.scrollHeight + 'px';
          });
        }
      }
    });

    // transition 終了後に max-height を調整
    target.addEventListener('transitionend', (e) => {
      if (e.propertyName !== 'max-height') return;

      if (target.classList.contains('is-open')) {
        target.style.maxHeight = 'none';
      } else {
        target.style.maxHeight = '';
      }
    });
  });
};
